import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Education } from '../../../../icons/education';
import { ExperienceIcon } from '../../../../icons/experience';
import { KeyAttributes } from '../../../../icons/key-attribute';
import { Mail } from '../../../../icons/mail';
import { Skills } from '../../../../icons/skills';
import { SocialLink } from '../../../../icons/social-link';
import { SocialPerson } from '../../../../icons/social-person';
import STRING_KEYS from '../../../../language/keys';
import { Navigation } from '../../../../components/Navigation';
import { navBarStyle } from './style';

type TalentLeftNavBarProps = {
  valuesField: InitialStateTalentsEditForm,
  socialLinksCounter: number,
  isBasicDetailsError: boolean,
  isSocialLinksError: boolean,
  isSkillsError: boolean,
  isAtrributesError: boolean,
};
export const TalentLeftNavBar = (
  {
    valuesField,
    socialLinksCounter,
    isBasicDetailsError,
    isSocialLinksError,
    isSkillsError,
    isAtrributesError,
  }: TalentLeftNavBarProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const [isOpenNav, setIsOpenNav] = useState<boolean>(true);

  const handleOpenNavClick = () => {
    setIsOpenNav(!isOpenNav);
  };

  const getNavItemStyle = useCallback((isError:boolean) => {
    if (isError) {
      return navBarStyle.errorStyle;
    }

    return navBarStyle.defaultStyle;
  }, []);

  const navList = [
    {
      icon:
  <SocialPerson
    viewBox="0 0 20 20"
    sx={ getNavItemStyle(isBasicDetailsError) }
  />,
      counter: 5 + valuesField.phones.length + valuesField.emails.length,
      hash: '#basic-details',
      title: translate(STRING_KEYS.BASIC_DETAILS),
      isError: isBasicDetailsError,
    },
    {
      icon: <Mail />,
      counter: valuesField.phones.length + valuesField.emails.length,
      hash: '#contact-details',
      title: translate(STRING_KEYS.CONTACT_INFORMATION),
      isError: false,
    },
    {
      icon:
  <SocialLink
    viewBox="0 0 20 20"
    sx={ getNavItemStyle(isSocialLinksError) }
  />,
      counter: socialLinksCounter,
      hash: '#social-links',
      title: translate(STRING_KEYS.SOCIAL_LINKS),
      isError: isSocialLinksError,
    },
    {
      icon: <ExperienceIcon viewBox="0 0 20 20" />,
      counter: valuesField?.employmentHistory?.length || 0,
      hash: '#experience',
      title: translate(STRING_KEYS.EXPERIENCE),
      isError: false,
    },
    {
      icon: <Education viewBox="0 0 20 20" />,
      counter: valuesField?.educationHistory?.length || 0,
      hash: '#education',
      title: translate(STRING_KEYS.EDUCATION),
      isError: false,
    },
    {
      icon:
  <KeyAttributes
    viewBox="0 0 20 20"
    sx={ getNavItemStyle(isAtrributesError) }
  />,
      counter: valuesField?.attributes?.length || 0,
      hash: '#key-attributes',
      title: translate(STRING_KEYS.KEY_ATTRIBUTES),
      isError: isAtrributesError,
    },
    {
      icon:
  <Skills
    viewBox="0 0 20 20"
    sx={ getNavItemStyle(isSkillsError) }
  />,
      counter: valuesField?.skills?.length || 0,
      hash: '#skills',
      title: translate(STRING_KEYS.SKILLS),
      isError: isSkillsError,
    },
  ];

  return (
    <Navigation
      title={ translate(STRING_KEYS.TITLE_NAVIGATION, { title: 'Talents' }) }
      navList={ navList }
      onOpenNavClick={ handleOpenNavClick }
      isOpenNav={ isOpenNav }
    />
  );
};
